"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBootstrapLiveLens = exports.handleUserMedia = void 0;
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const react_1 = require("react");
const camera_utils_1 = require("../lib/camera-utils");
const grafana_1 = require("../lib/grafana");
const liveLensState_1 = require("../liveLensState");
const web_sentry_1 = require("@snapchat/web-sentry");
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
const web_env_1 = require("@snapchat/web-env");
async function importCamKitSdk() {
    const { bootstrapCameraKit, Transform2D, createMediaStreamSource } = await Promise.resolve().then(() => __importStar(require("@snap/camera-kit")));
    return { bootstrapCameraKit, Transform2D, createMediaStreamSource };
}
const getLensViewEventHandler = (pageType, deviceName) => (event) => {
    const avgFps = Math.round(event.detail.avgFps);
    const avgFpsRangeStart = Math.round(avgFps / 10) * 10;
    const avgFpsRangeEnd = avgFpsRangeStart + 10 - 1;
    (0, grafana_1.incrementCounter)(`avgFPS.${avgFps}.${web_blizzard_reporting_1.PageType[pageType]}.${deviceName}`);
    (0, grafana_1.incrementCounter)(`avgFPS.${avgFpsRangeStart}.to.${avgFpsRangeEnd}.${web_blizzard_reporting_1.PageType[pageType]}.${deviceName}`);
    (0, grafana_1.addTimer)({
        metricsPrefix: grafana_1.grafanaBasePrefix,
        pageName: web_blizzard_reporting_1.PageType[pageType],
        millis: Math.round(event.detail.lensFrameProcessingTimeMsAvg),
        name: `lensFrameProcessingTimeMsAvg.${deviceName}`,
    });
    (0, grafana_1.addTimer)({
        metricsPrefix: grafana_1.grafanaBasePrefix,
        pageName: web_blizzard_reporting_1.PageType[pageType],
        millis: Math.round(event.detail.lensFrameProcessingTimeMsStd),
        name: `lensFrameProcessingTimeMsStd.${deviceName}`,
    });
    (0, grafana_1.addTimer)({
        metricsPrefix: grafana_1.grafanaBasePrefix,
        pageName: web_blizzard_reporting_1.PageType[pageType],
        millis: Math.round(event.detail.viewTimeSec),
        name: `viewTimeSec.${deviceName}`,
    });
    (0, grafana_1.addTimer)({
        metricsPrefix: grafana_1.grafanaBasePrefix,
        pageName: web_blizzard_reporting_1.PageType[pageType],
        millis: Math.round(event.detail.applyDelaySec),
        name: `applyDelaySec.${deviceName}`,
    });
};
const getUnknownErrorMessage = (e) => (e instanceof Error ? e.message : String(e));
async function handleUserMedia(pageType, setLiveLensState, webClientId) {
    try {
        const navigatorObj = (0, web_env_1.getNavigator)();
        if (!navigatorObj) {
            return;
        }
        const mediaStream = await navigatorObj.mediaDevices.getUserMedia({ video: true });
        (0, web_blizzard_reporting_1.reportWebAction)({
            pageType,
            actionName: web_blizzard_reporting_1.WebActionName.CamAccessGranted,
            webClientId,
        });
        return mediaStream;
    }
    catch (e) {
        (0, web_sentry_1.logSentryError)("Live Lens: handleUserMedia Error", e);
        if ((0, camera_utils_1.isCameraAccessDeniedError)(e)) {
            (0, grafana_1.incrementCounter)(`Errors.CamAccessDenied.${(0, grafana_1.getDeviceName)()}`);
            (0, web_blizzard_reporting_1.reportWebAction)({
                pageType,
                actionName: web_blizzard_reporting_1.WebActionName.CamAccessDenied,
                webClientId,
            });
            setLiveLensState(liveLensState_1.LiveLensState.CAMERA_PERMISSION_DENIED);
        }
        else {
            (0, grafana_1.incrementCounter)(`Errors.RequestCamAccessFailed.${(0, grafana_1.getDeviceName)()}`);
            (0, web_blizzard_reporting_1.reportWebAction)({
                pageType,
                actionName: web_blizzard_reporting_1.WebActionName.RequestCamAccessFailed,
                webClientId,
            });
            setLiveLensState(liveLensState_1.LiveLensState.CAMERA_NOT_FOUND);
        }
        (0, grafana_1.incrementCounter)(`Errors.${getUnknownErrorMessage(e)}.${(0, grafana_1.getDeviceName)()}`);
        throw e;
    }
}
exports.handleUserMedia = handleUserMedia;
function useBootstrapLiveLens({ setLiveLensState, lensId, lensGroupId, pageType, }) {
    const webClientId = (0, web_sc_cookies_1.useGetWebClientId)();
    const deviceName = (0, grafana_1.getDeviceName)();
    const liveLensCanvasRef = (0, react_1.useRef)(null);
    const sessionRef = (0, react_1.useRef)(null);
    const cameraKitRef = (0, react_1.useRef)(null);
    const mediaStreamRef = (0, react_1.useRef)(null);
    const [isFocused, setIsFocused] = (0, react_1.useState)((0, web_env_1.getDocument)()?.visibilityState === "visible");
    const stopCameraFeed = () => {
        // session.destroy() doesn't disable the mediaStream track, therefore we manually disable them
        // to ensure the media is completely closed.
        const tracks = mediaStreamRef.current?.getTracks();
        if (tracks) {
            for (const track of tracks) {
                // When true, enabled indicates that the track is permitted to render its actual media to the output.
                // When false, the track only generates empty frames and updates device activity indicators to show
                // that the camera is not currently recording or streaming.
                track.enabled = false;
                track.stop();
            }
        }
    };
    (0, react_1.useEffect)(() => {
        const handleVisibilityChange = () => {
            if ((0, web_env_1.getDocument)()?.visibilityState === "visible") {
                setIsFocused(true);
                setLiveLensState(liveLensState_1.LiveLensState.REQUESTED);
            }
            else {
                setIsFocused(false);
                stopCameraFeed();
            }
        };
        (0, web_env_1.getDocument)()?.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            (0, web_env_1.getDocument)()?.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [setLiveLensState]);
    (0, react_1.useEffect)(() => {
        // don't render live lens if out of focus
        if (!isFocused) {
            return;
        }
        const lensViewEventHandler = getLensViewEventHandler(pageType, deviceName);
        // request live lens on mount of this application
        const sdkDownloadStartTime = new Date().getTime();
        setLiveLensState(liveLensState_1.LiveLensState.DOWNLOADING);
        void importCamKitSdk()
            .then(({ bootstrapCameraKit, Transform2D, createMediaStreamSource }) => {
            const sdkDownloadTime = new Date().getTime() - sdkDownloadStartTime;
            (0, grafana_1.addTimer)({
                metricsPrefix: grafana_1.grafanaBasePrefix,
                millis: sdkDownloadTime,
                pageName: web_blizzard_reporting_1.PageType[pageType],
                name: `cameraKitSdkBundleDownloadTime.${deviceName}`,
            });
            const loadCamKit = async () => {
                const camKitApiToken = process.env.NEXT_PUBLIC_CAMKIT_API_TOKEN;
                if (!camKitApiToken) {
                    throw new Error("Missing value for environment variable CAMKIT_API_TOKEN");
                }
                setLiveLensState(liveLensState_1.LiveLensState.BOOTSTRAPPING);
                cameraKitRef.current = await bootstrapCameraKit({ apiToken: camKitApiToken || "" });
                const canvasContainer = liveLensCanvasRef.current;
                sessionRef.current = await cameraKitRef.current.createSession();
                const session = sessionRef.current;
                cameraKitRef.current.metrics.addEventListener("lensView", lensViewEventHandler);
                // remove any previous canvas
                if (canvasContainer?.innerHTML) {
                    canvasContainer.innerHTML = "";
                }
                canvasContainer?.appendChild(session.output.live);
                setLiveLensState(liveLensState_1.LiveLensState.GETTING_PERMISSION);
                let mediaStream;
                try {
                    mediaStream = await handleUserMedia(pageType, setLiveLensState, webClientId ?? "");
                    if (mediaStream) {
                        mediaStreamRef.current = mediaStream;
                    }
                }
                catch (e) {
                    // logged in handleUserMedia
                    return;
                }
                if (mediaStream) {
                    const cameraKitSource = createMediaStreamSource(mediaStream);
                    await session.setSource(cameraKitSource);
                    await cameraKitSource.setTransform(Transform2D.MirrorX);
                    // render with max desktop resolution for better performance
                    await cameraKitSource.setRenderSize(360, 640);
                    setLiveLensState(liveLensState_1.LiveLensState.LOADING_LENS);
                    const lens = await cameraKitRef.current.lenses.repository.loadLens(lensId, lensGroupId);
                    setLiveLensState(liveLensState_1.LiveLensState.APPLYING_LENS);
                    await session.applyLens(lens);
                    await session.play();
                    setLiveLensState(liveLensState_1.LiveLensState.APPLIED);
                    (0, grafana_1.incrementCounter)(`Applied.${(0, grafana_1.getDeviceName)()}`);
                }
            };
            loadCamKit().catch((e) => {
                (0, web_sentry_1.logSentryError)("Live Lens: loadCamKit Error", e);
                (0, grafana_1.incrementCounter)(`Errors.CamKit.${getUnknownErrorMessage(e)}.${(0, grafana_1.getDeviceName)()}`);
                setLiveLensState(liveLensState_1.LiveLensState.FAILED);
            });
        })
            .catch((e) => {
            (0, web_sentry_1.logSentryError)("Live Lens: importCamKitSdk Error", e);
            (0, grafana_1.incrementCounter)(`Errors.CamKit.${getUnknownErrorMessage(e)}.${(0, grafana_1.getDeviceName)()}`);
            setLiveLensState(liveLensState_1.LiveLensState.FAILED);
        });
        return () => {
            stopCameraFeed();
            // destroy session when unmounting
            void sessionRef.current?.removeLens().then(() => {
                cameraKitRef.current?.metrics.removeEventListener("lensView", lensViewEventHandler);
                void sessionRef.current?.destroy();
            });
        };
    }, 
    // setLiveLensState should be stable
    [lensId, lensGroupId, setLiveLensState, pageType, isFocused, deviceName, webClientId]);
    return liveLensCanvasRef;
}
exports.useBootstrapLiveLens = useBootstrapLiveLens;
//# sourceMappingURL=useBootstrapLiveLens.js.map